import styled from 'styled-components';

import QuestionContainerDef from 'components/QuestionContainer';

export const QuestionContainer = styled(QuestionContainerDef)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
  gap: 10px;
`;

export const Label = styled.p`
  color: var(--color-grey6A);
  font-size: var(--font-size15);
  border-top: 1px solid var(--color-greyEC);
  padding-top: 10px;
  margin-top: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
